import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { _CostingCenter } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../../theme/Component/PrintJson";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    UseBudgetAccountantToPayroll: boolean;
    UseMappedCostBudgetID: boolean;
    UseMappedCostAccountantIDForExp: boolean;
    UseCostAccountantIDForExp: boolean;
    Name: string;
    Code: string;
    Description: string;
}

export const SOLCENCOST002 = ({ configProcedure }: Props) => {

    const { instance } = useDataBean(_CostingCenter);
    const [props, setProps] = useState<any>({});
    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        setResponse({ ...response, Code: props.Code })
    }, [props])

    const [response, setResponse] = useState<Partial<Resp>>({
        UseBudgetAccountantToPayroll: false,
        UseMappedCostBudgetID: false,
        UseMappedCostAccountantIDForExp: false,
        UseCostAccountantIDForExp: false
    })

    const onExportMap = (obj: any) => {
        configProcedure?._pushProps(obj);

        configProcedure?._pushInfo(_single.jsonToBootstrapTable({
            "Nombre": obj.Name,
            "Código": obj.Code,
            "Descripción": obj.Description,
        }))

        configProcedure?._exportMap(obj)
    }

    const createItem = () => {
        instance.updateCostingCenter(response).then(
            (resp) => {
                onExportMap(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createItem();
        }
    }

    const validateForm = () => {
        const requiredFieldsCash = [
            "Name", "Code", "Description"
        ];


        let missing = [];

        for (let field of requiredFieldsCash) {
            if (response[field] === null || response[field] === undefined || response[field] === "") {
                missing.push(field);
            }
        }

        setMissingFields(missing);
        return missing.length
    };


    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <label>Nombre</label>
                    <input type="text" name="Name" className="form-control" value={response.Name} onChange={(e) => { setResponse({ ...response, Name: e.target.value }) }} />
                </div>

                <div className="col-md-6">
                    <label>Código</label>
                    <input type="text" disabled name="Code" className="form-control" value={response.Code} onChange={(e) => { setResponse({ ...response, Code: e.target.value }) }} />
                </div>

                <div className="col-md-12">
                    <label>Descripción</label>
                    <textarea name="Description" className="form-control" value={response.Description} onChange={(e) => { setResponse({ ...response, Description: e.target.value }) }} />
                </div>

                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={() => { validateData() }} >Crear Centro de Costo</BasicButton>
                </div>
            </div>
        </>
    );
};